/**
 * Pagination constants used across the application
 */

export const PAGINATION = {
  // Core defaults
  DEFAULT_PAGE: 1 as number,
  DEFAULT_PAGE_SIZE: 10 as number,

  // Context-specific sizes
  SINGLE_RECORD: 1 as number,           // Fetch one record by UUID
  DROPDOWN_SIZE: 20 as number,          // Dropdowns/exhibitor queries
  DROPDOWN_SIZE_LARGE: 50 as number,    // Larger dropdowns
  BULK_SIZE: 1000 as number,            // Bulk exports/reports
  BULK_SIZE_XLARGE: 10000 as number,    // Very large bulk (all educators)

  // UI page size options
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50] as number[],
  PAGE_SIZE_OPTIONS_LARGE: [10, 25, 50, 100] as number[],
  PAGE_SIZE_OPTIONS_ORDERS: [5, 10, 20, 50] as number[],

  // Helper functions
  defaultPaging: () => ({ page: 1 as number, pageSize: 10 as number }),
  singleRecordPaging: () => ({ page: 1 as number, pageSize: 1 as number }),
  dropdownPaging: (size: number = 20) => ({ page: 1 as number, pageSize: size as number }),
  bulkPaging: (size: number = 1000) => ({ page: 1 as number, pageSize: size as number })
} as const;

/** Type for pagination parameters */
export interface PaginationParams {
  page: number;
  pageSize: number;
}
